<script setup>

import { useI18n } from 'vue-i18n'
import { onMounted, ref,reactive } from 'vue'
import {getTemplateListAPI,addTemplateAPI,setEditTemplateAPI,setDelTemplateAPI,getProductTranslationAPI} from '@/apis/category'
const { t } = useI18n();
const isMobile=ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    getTemplateList()
    skutranslate.value='zn'
    skutranslateLanguage.value='all'
})
/**
 * 获取模版列表
 */
 const param =reactive({
    data:{
        page: 1,
        page_size: 5,
    },
    total: 0,
})
const TemplateList=ref([]);
const getTemplateList=async ()=>{
    const res = await getTemplateListAPI(param.data)
      if (res.code == 0) {
        if(res.data.list==null){
            TemplateList.value=[]
        }else{
            TemplateList.value = res.data.list

        }
        param.total = res.data.total
        
        console.log('TemplateList.value',TemplateList.value)
      }
}
// 页数切换
const pageChange = (page) => {
    param.data.page = page
    getTemplateList()
}
 //删除
const delskuData=async(item)=>{
    const res = await setDelTemplateAPI({template_id:item.template_id})
    if(res.code==0){
        ElMessage({ type: 'success', message: t('number112') });
        getTemplateList()
    }else{
        ElMessage({ type: 'error', message: res.message })
    }
}
const standardForm=reactive({
      name:{
          zn:'',
          en_us:'',
          esp:'',
          pcp:'',
          ned:'',
          pl:'',
          de:'',
          pcf:'',
          ita:''
      }
})
const standardModel=ref(false);
const standardFormRef = ref(null);
const standardrules={
    "name.en_us": [
    { required: true, message: t('setup508'), trigger: 'blur' }
    ],
    "name.zn": [
    { required: true, message: t('setup509'), trigger: 'blur' }
    ],
  }
const handleClose=()=>{
      standardModel.value=false
      standardFormRef.value.resetFields();
}


const Tiers=ref(0)
const data=ref()
//修改父级
const editSkuData=(item)=>{
     skutranslate.value='zn'
    skutranslateLanguage.value='all'
    // 
    data.value=item
    Tiers.value=1
    standardForm.name=item.name
    standardModel.value=true
}
//修改子集
const itemIndex=ref()
const handleDoubleClick=(item,i,index)=>{
    skutranslate.value='zn'
    skutranslateLanguage.value='all'
    Tiers.value=2
    data.value=item;
    standardForm.name=i.name
    itemIndex.value=index
    standardModel.value=true
    console.log(standardForm,data.value)
}
//删除子级
const delskuSubsetData=async (item,index)=>{
    
    item.values.splice(index, 1); 

    const res = await addTemplateAPI(item)
    if(res.code==0){
        ElMessage({ type: 'success', message: t('number112') });
        getTemplateList();
    }
}
//添加规格值
const standard=(item)=>{
    Tiers.value=3
    data.value=item;
    standardForm.name.zn=''
    standardForm.name.en_us=''
    standardForm.name.esp=''
    standardForm.name.pcp=''
    standardForm.name.ned=''
    standardForm.name.pl=''
    standardForm.name.de=''
    standardForm.name.pcf=''
    standardForm.name.ita=''
    
    standardModel.value=true
}
 /**
  * 编辑或新增
  */
  const standardSubmit=()=>{
    standardFormRef.value.validate(async (valid) => {
        if(valid){
            if(Tiers.value==1){//表示编辑父级
                const name=JSON.parse(JSON.stringify(standardForm.name))
                data.value.name=name
                const res = await setEditTemplateAPI(data.value)
                if(res.code==0){
                    ElMessage({ type: 'success', message: t('setup605') });
                    getTemplateList();
                }
            }else if(Tiers.value==2){//表示编辑子级
                const name=JSON.parse(JSON.stringify(standardForm.name))
                data.value.values[itemIndex]=name
                const res = await addTemplateAPI(data.value)
                if(res.code==0){
                    ElMessage({ type: 'success', message: t('setup605') });
                    getTemplateList();
                }
            }else{//表示添加
                const name=JSON.parse(JSON.stringify(standardForm.name))
               
                const hasM = data.value.values.some(item => item.name.zn === name.zn);
                if(!hasM){
                    data.value.values.push({name:name})
                    const res = await addTemplateAPI(data.value);
                    if(res.code==0){
                        ElMessage({ type: 'success', message: t('setup606') });
                        getTemplateList();
                    }
                }else{
                    ElMessage({
                            message: t('setup601'),
                            type: 'warning',
                      
                    })
                }
                
            }
            handleClose()
        }
    })
  }
  const  languageAll= [
{
    value: 'all',
    label: t('setup620'),
},  
  {
    value: 'en_us',
    label: 'English',
  },
  {
    value: 'esp',
    label: t('setup523'),
  },
  {
    value: 'pcp',
    label: t('setup524'),
  },
  {
    value: 'ned',
    label: t('setup525'),
  },
  {
    value: 'pl',
    label: t('setup526'),
  },
  {
    value: 'de',
    label: t('setup527'),
  },
  {
    value: 'pcf',
    label: t('setup528'),
  },
  {
    value: 'ita',
    label: t('setup529'),
  },
]
const defaultlang=[
    {
        value: 'zn',
        label: t('setup522'),
    }, 
    {
        value: 'en_us',
        label: 'English',
    },
  {
    value: 'esp',
    label: t('setup523'),
  },
  {
    value: 'pcp',
    label: t('setup524'),
  },
  {
    value: 'ned',
    label: t('setup525'),
  },
  {
    value: 'pl',
    label: t('setup526'),
  },
  {
    value: 'de',
    label: t('setup527'),
  },
  {
    value: 'pcf',
    label: t('setup528'),
  },
  {
    value: 'ita',
    label: t('setup529'),
  },
]
const skutranslate=ref()
const skutranslateLanguage=ref()
const skutranslateLoading=ref(false)
/**
 * 翻译
 * type 1表示标题
 * 2表示规格
 */
 const interpret=async ()=>{
       let text=''
       
       
        if(skutranslate.value=='zn'){
            if(standardForm.name.zn==''){
                ElMessage({ type: 'warning', message: t('setup609') });
                return;
            }else{
                text=standardForm.name.zn
            }
        }else if(skutranslate.value=='en_us'){
            if(standardForm.name.en_us==''){
                ElMessage({ type: 'warning', message: t('setup610') });
                return;
            }else{
                text=standardForm.name.en_us
            }
        }else if(skutranslate.value=='esp'){
            if(standardForm.name.esp==''){
                ElMessage({ type: 'warning', message: t('setup611') });
                return;
            }else{
                text=standardForm.name.esp
            }
        }else if(skutranslate.value=='pcp'){
            if(standardForm.name.pcp==''){
                ElMessage({ type: 'warning', message: t('setup612') });
                return;
            }else{
                text=standardForm.name.pcp
            }
        }else if(skutranslate.value=='ned'){
            if(standardForm.name.ned==''){
                ElMessage({ type: 'warning', message: t('setup613') });
                return;
            }else{
                text=standardForm.name.ned
            }
        }else if(skutranslate.value=='pl'){
            if(standardForm.name.pl==''){
                ElMessage({ type: 'warning', message: t('setup614') });
                return;
            }else{
                text=standardForm.name.pl
            }
        }else if(skutranslate.value=='de'){
            if(standardForm.name.de==''){
                ElMessage({ type: 'warning', message: t('setup615') });
                return;
            }else{
                text=standardForm.name.de
            }
        }else if(skutranslate.value=='pcf'){
            if(standardForm.name.pcf==''){
                ElMessage({ type: 'warning', message: t('setup616') });
                return;
            }else{
                text=standardForm.name.pcf
            }
        }else if(skutranslate.value=='ita'){
            if(standardForm.name.ita==''){
                ElMessage({ type: 'warning', message: t('setup617') });
                return;
            }else{
                text=standardForm.name.ita
            }
        }
    
            let data={
                from:skutranslate.value,
                language:skutranslateLanguage.value,
                text:text
            }
            skutranslateLoading.value=true
            const res=await getProductTranslationAPI(data);
            if(res.code==0){
                console.log(skutranslateLanguage.value)
                skutranslateLoading.value=false;
                if(skutranslateLanguage.value=='all'){
                    standardForm.name.de=res.data.de
                    standardForm.name.en_us=res.data.en_us
                    standardForm.name.esp=res.data.esp
                    standardForm.name.ita=res.data.ita
                    standardForm.name.ned=res.data.ned
                    standardForm.name.pcf=res.data.pcf
                    standardForm.name.pcp=res.data.pcp
                    standardForm.name.pl=res.data.pl
                    standardForm.name.zn=res.data.zn
                }else{  
                    standardForm.name[skutranslateLanguage.value] = res.data[skutranslateLanguage.value];
                }
            }
      
    
}
</script>
<template>
    <div class="CommonTemplate">

        <div class="home-panel">
            <div class="header-top" >{{ $t('setup591') }}</div>
            <div class="cart-none" v-if="TemplateList?.length === 0">
                <el-empty :description="t('setup11')">

                </el-empty>
            </div>
            <div v-else class="CommonAll">
                <div class="multiSkuData">
                    <div class="containerDiv" v-for="(item,index) in TemplateList" :key="index">
                        <div class="header">
                            <div class="headerLeft">
                                <span>{{ item.name?.zn}}</span>
                                <span class="spanCkick" @click="editSkuData(item)">{{$t('number24')}}</span>
                                <span class="spanCkick" style="color: #FC3938;" @click="delskuData(item)">{{ $t('number119') }}</span>
                            </div>
                            <div class="headerRight">
                                <div class="checkboxdiv">
                                    <el-button color="#FC3938" plain @click="standard(item)">{{ $t('setup533') }}</el-button>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                                                  
                            <div >
                                <div class="flex">
                                    <div class="Draggable">
                                    <div
                                        v-for="(items,indexs) in item?.values"
                                        :key="indexs"
                                        class="DraggableItem"
                                        @dblclick="handleDoubleClick(item,items,indexs)"
                                        >
                                        {{ items.name?.zn }}
                                        <span class="delete-icon" @click="delskuSubsetData(item,indexs)">
                                    
                                            <svg-icon icon-class="close" style="width: 20px;height: 25px;"/>
                                        </span>
                                    </div>
                                </div>
                                    <!-- <preview-list :list="item.values" /> -->
                                </div>
                                <p style="    padding-left: 10px;">{{ $t('setup602') }}</p>
                            </div>
                        </div>
                      
                    </div> 
                </div>
              
                <div class="page">
                    <el-pagination :total="param.total"  v-model:current-page="param.data.page"
  @current-change="pageChange"   background 
  :page-size="param.data.page_size"
                        layout="prev, pager, next" />
                </div>
            </div>
        </div>
        <el-dialog
      v-model="standardModel"
      :title="t('number24')"
      width="750"
      :before-close="handleClose"
    >
      <el-form v-if="standardModel" ref="standardFormRef" :model="standardForm"  :rules="standardrules" label-width="auto" style="max-width: 600px">
          <el-form-item :label="t('setup538')" prop="name" >
              <div>
                  <el-form-item prop="name.zn" class="custom-form-item bottom-padding" >
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.zn" :placeholder="t('setup522')" style="width: 600px;">
                              <template #prepend><div style="width: 100px;">{{$t('setup522')}}</div></template>
                          </el-input>
                      </div>
                  </el-form-item>
                  <div class="HorizontalCenter" style="padding: 10px 0;margin-bottom: 10px;background: #f4f6f9;">
                    {{ $t('setup618') }}: 
                    <el-select
                    v-model="skutranslate"
                    style="width: 180px;margin-left: 10px;"
                    >
                    <el-option
                        v-for="item in defaultlang"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                    </el-select>
                    <svg-icon icon-class="arrow" style="width: 35px;height: 30px;"/>
                    <el-select v-model="skutranslateLanguage" placeholder="Select" style="width: 180px"  >
                        <el-option
                            v-for="item in languageAll"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                    <el-button type="danger" plain style="margin-left: 10px;" :loading="skutranslateLoading" @click="interpret()">{{ $t('setup619') }}</el-button>
                    </div>
                  <el-form-item prop="name.en_us" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.en_us" placeholder="English" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">English</div></template>
                          </el-input>
                      </div>
                  </el-form-item>
                  <el-form-item prop="name.esp" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.esp" :placeholder="t('setup523')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{t('setup523')}}</div></template>
                          </el-input>
                      </div>
                  </el-form-item>
                  <el-form-item prop="name.pcp" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.pcp" :placeholder="t('setup524')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup524')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.ned" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.ned" :placeholder="t('setup525')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup525')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.pl" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.pl" :placeholder="t('setup526')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup526')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.de" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.de" :placeholder="t('setup527')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup527')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.pcf" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.pcf" :placeholder="t('setup528')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup528')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.ita" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.ita" :placeholder="t('setup529')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{ $t('setup529') }}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
              </div>
          </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleClose">Cancel</el-button>
          <el-button type="primary" @click="standardSubmit">
            Confirm
          </el-button>
        </div>
      </template>
    </el-dialog>
    </div>
</template>
<style scoped lang="scss">
.CommonTemplate{
    .home-panel {
        background-color: #fff;
        padding: 20px 20px 20px 20px;
        height: 100%;
        border-radius: 8px;


        .header-top {
            height: 46px;
            border-bottom: 1px solid #f5f5f5;
            padding: 18px 0;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #11192D;
            line-height: 18px;
            text-align: left;
            font-style: normal;
        }
        .CommonAll{
            .multiSkuData{
                width: 100%;
                .containerDiv {
                    margin-top: 10px;
                width: 832px;
                // padding: 20px;
                border: 1px solid  #dfe6ec;
                }
            
                .header {
                    display: flex;
                    padding: 8px 10px;
                    justify-content: space-between;
                    // margin-bottom: 20px;s
                    background: #F3F6F8;
                    // border: 1px solid #E5E8EC;
                    align-items: center;
                    .headerLeft{
                        span {
                        margin-right: 10px;
                        
                        }
                        .spanCkick{
                            color: #468ffb;
                        }
                    }
                    .headerRight{
                        display: flex;
                        
                        .checkbox{
                        //    border: 1px solid #d9dce3;
                        //    padding: 0px 15px;
                        //    border-radius: 4px;
                        //    margin-top: 10px;
                        
                        }
                        .checkboxdiv{
                            margin-top: -10px;
                            margin-left: 10px;
                            // padding: 0 5px;
                            // border: 1px solid #d9dce3;
                            // display: flex;
                            // align-items: center;
                            // border-radius: 4px;
                            // color: #606266;
                            // font-size: 14px;
                            // font-weight:500
                        }
                    }
                }
                
                .CommonContent{
                    padding: 10px;
                    .CommonItem{
                        display: flex;
                        flex-wrap: wrap;
                        .popover{
                            .item{
                                padding: 4px 10px;
                                border: 1px solid #dfe6ec;
                                margin: 10px;
                                display: flex;
                                justify-content: center;
                                align-items: center;  
                            }
                            
                        }
                    
                        
                    
                    
                    }
                }
            
                .content {
                    .Draggable{
                        display: flex;
                        flex-wrap: wrap;
                        .DraggableItem{
                            padding: 4px 10px;
                            border: 1px solid #dfe6ec;
                            margin: 10px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            cursor: pointer;
                            .delete-icon {
                                position: absolute;
                                top: 4%;
                                right: -8px;
                                transform: translateY(-50%);
                                opacity: 0;
                                transition: opacity 0.3s;
                                cursor: pointer;
                            }
                            &:hover .delete-icon{
                                opacity: 1;
            
                            }
                        }
                    }
                    
                    .contentbut{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 20px;
                    }
                }
                
            
                
            
                button {
                margin-top: 10px;
                }
            }
            .page {
            display: flex;
            justify-content: flex-end;
            padding: 20px 0;
        }
        }

    }
}</style>